module.exports = __webpack_public_path__ + "static/media/apf.145509af.svg";